import InviteFriendsDialog from "./InviteFriendsDialog";
import ShareProductDialog from "./ShareProductDialog";
import ConnectRetailerDialog from "./ConnectRetailerDialog";
import SurveyLimitDialog from "./SurveyLimitDialog";
import DisconnectRetailerDialog from "./DisconnectRetailerDialog";
import GenericDialog from "./GenericDialog";
import GenericDialogNoClose from "./GenericDialogNoClose";
import LoadingOverlay from "./LoadingOverlay";
import EditConnectPopup from "@/components/Checkout/components/CheckoutV2/CheckoutForm/components/retailerConnect/EditConnectPopup";
import { ProductReturnDialog } from "./ProductReturnDialog";
import PaymentVerificationPopup from "@/components/Checkout/components/CheckoutV2/CheckoutForm/components/retailerConnect/PaymentVerificationPopup";
import OTPDialog from "@/components/Checkout/components/CheckoutV2/CheckoutForm/components/retailerConnect/EditConnectPopup/OTPDialog";

const AppDialogs = () => {
  return (
    <>
      {/* Dialogs */}
      <InviteFriendsDialog />
      <ShareProductDialog />
      <ConnectRetailerDialog />
      <DisconnectRetailerDialog />
      <GenericDialog />
      <GenericDialogNoClose />
      <SurveyLimitDialog />
      <EditConnectPopup />
      <OTPDialog />
      <ProductReturnDialog />
      <PaymentVerificationPopup />

      {/* Overlays */}
      <LoadingOverlay />
    </>
  );
};

export default AppDialogs;
